import EcoImg from 'eco-design-components/base/eco-img';
import EcoSpace from 'eco-design-components/base/eco-space';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';

const N: React.FC = () => {
    const webpOrJpg = useWebpOrJpg('#rapid-mag-N-V2');
    return (
        <section className={`${css.section}  GtmModuleData-section`} id="rapid-mag-N-V2" data-section-id="rapid-mag-N-V2" data-section-title="Brand-Info">
            <EcoSpace />
            <EcoImg
                pc={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1749804772138/N-pc.jpg')}
                pad={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1749804772138/N-pc.jpg')}
                h5={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1749804771929/N-h5.jpg')}
            />
            <EcoSpace />
        </section>
    );
};

export default N;
